import React, { Component } from 'react';
import AuthTokenService from '../service/authTokenService';
import { useParams, useNavigate, useSearchParams} from 'react-router-dom';

import "../design/loginform.css";
import AuthorizationHelper from '../helper/AuthorizationHelper';


function withParams(Component) {
  return props => <Component {...props} searchParams={useSearchParams()} params={useParams()} Navigate={useNavigate()} />;
}

class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userName: "",
            password: ""
        }

        this.handleChange = this.handleChange.bind(this);
        this.authTokenService = new AuthTokenService();
        this.authorizationHelper = new AuthorizationHelper();
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    componentDidMount() {
        document.title = "Login";
    }

    async onSubmitClick(event) {
        event.preventDefault();
        if(!await this.authorizationHelper.loginUser(this.state.userName, this.state.password)){
            this.props.Navigate("/Login")
            return;
        }
        this.props.Navigate("/")
    }

    render() {
        return (
            <div className="App">
                <div id="LoginDiv" className='content'>
                    <form action="#" onSubmit={(event) => { this.onSubmitClick(event) }}>
                        <label className="labelLoginForm" htmlFor="userName">Username:</label>
                        <input className="loginInputLabel" type="text" name="userName" placeholder="Enter your username." value={this.state.userName} onChange={this.handleChange} required /><br />
                        <label className="labelLoginForm" htmlFor="password">Password:</label>
                        <input className="loginInputLabel" type="password" name="password" placeholder="Enter your password" value={this.state.password} onChange={this.handleChange} required /><br />
                        <button className="buttonLoginSubmit" type="submit">Login</button>
                    </form>
                </div>
            </div>
        )
    }
}

export default withParams(Login);
